import { BallBg, Text } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AthletePicker, Banner, Shoutout } from './components';

const TitleText = styled(Text)`
  width: 1140px;
  align-selft: center;
  margin: 0 auto;
  margin-top: 31px;
  left: 0px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const OurAthletes = (props) => {
  const { t } = useTranslation();
  /*
  const [data, setData] = useState(null),
    [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchInitial()
  }, [])

  async function fetchInitial() {
    const res = await Api.get('/website/fetchInitial')
    if(!res) return

    setData(res)
    setLoading(false)
  }
  */

  return (
    <React.Fragment>
      <BallBg />

      <TitleText lineHt="30px" size="20px">
        {t('website.ourAthletesSmall')}
      </TitleText>

      <Banner />

      <AthletePicker />

      <Shoutout />
    </React.Fragment>
  );
};

export default OurAthletes;
